import { useReducer } from 'react'

/**
 * @typedef {import('react')} React
 */

/**
 * @template {Record<string, any>} T
 * @param {T} initialState
 * @returns {[T, React.Dispatch<Partial<T>>, (newState?: T) => void]}
 */
export const useSimpleReducer = initialState => {
  /** @type {React.Reducer<T, Partial<T>>} */
  const reducer = (prevState, updates) => ({ ...prevState, ...updates })
  const [state, dispatch] = useReducer(reducer, initialState)
  /**
   * @param {T} [state]
   * @returns {void}
   */
  const reset = (state = initialState) => dispatch(state)
  return [state, dispatch, reset]
}
